module.exports = __webpack_public_path__ + "img/red_017.6f4bf26e.png";